import React from 'react';
import Button from '@material-ui/core/Button';
import Link from 'react-router-dom/Link';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import CheckCircleOutlineIcon from '../../assets/img/CheckCircleOutline';
import IconAgepPeople from '../../../Layout/assets/img/icon-agep-people.svg';
import IconAgepClock from '../../../Layout/assets/img/icon-agep-clock.svg';
import IconAgepOpenBook from '../../../Layout/assets/img/icon-agep-open-book.svg';

const CourseDetailsPlaceholder = () => (
    <article className="course placeholder">
        <header>
            <div className="row no-gutters">
                <div className="col col-left col-7">
                    <Button size="medium" className="btnBack" component={props => <Link to="/formations" {...props}/>}>
                        <KeyboardBackspaceIcon className="btnIcon" />
                        Retour
                    </Button>

                    <h1>
                        <span className="placeholder-line"></span>
                        <span className="placeholder-line"></span>
                    </h1>

                    <span className="category">
                        <span className="placeholder-line"></span>
                    </span>

                    <ul className="highlight clearfix">
                        <li>
                            <div className="icon">
                                <img src={IconAgepPeople} alt="Disponibilité" />
                            </div>
                            <div className="content">
                                <span className="title">Disponibilité</span>
                                <span className="txt">
                                    <span className="placeholder-line"></span>
                                </span>
                            </div>
                        </li>
                        <li>
                            <div className="icon">
                                <img src={IconAgepClock} alt="Durée" />
                            </div>
                            <div className="content">
                                <span className="title">Durée</span>
                                <span className="txt">
                                    <span className="placeholder-line"></span>
                                </span>
                            </div>
                        </li>
                        <li>
                            <div className="icon">
                                <img src={IconAgepOpenBook} alt="Nombre de cours" />
                            </div>
                            <div className="content">
                                <span className="title">Nombre de cours</span>
                                <span className="txt">
                                    <span className="placeholder-line"></span>
                                </span>
                            </div>
                        </li>
                    </ul>
                </div>
                <div className="col col-right col-4 offset-1">
                    <div id="aside">
                        <div className="inner">
                            <div className="content">
                                <ul className="clearfix">
                                    <li>
                                        <span className="title">Prochaine session</span>
                                        <div className="content">
                                            <span className="placeholder-line"></span>
                                        </div>
                                    </li>
                                    <li>
                                        <span className="title">Prix public / partenaire</span>
                                        <div className="content">
                                            <span className="placeholder-line"></span>
                                        </div>
                                    </li>
                                    <li>
                                        <span className="title">Lieu de formation</span>
                                        <div className="content">
                                            <span className="placeholder-line"></span>
                                            <span className="placeholder-line"></span>
                                            <span className="placeholder-line"></span>
                                            <a href="#">Voir sur Google Maps</a>
                                        </div>
                                    </li>
                                    <li>
                                        <span className="title">Langue</span>
                                        <div className="content">
                                            <span className="placeholder-line"></span>
                                        </div>
                                    </li>
                                    <li>
                                        <span className="title">Niveau</span>
                                        <div className="content">
                                            <span className="placeholder-line"></span>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </header>
        <div className="row row-content">
            <div className="col col-7">
                <section id="presentation">
                    <h2>Présentation</h2>
                    <div className="content">
                        <span className="placeholder-line"></span>
                        <span className="placeholder-line"></span>
                        <span className="placeholder-line"></span>
                        <span className="placeholder-line"></span>
                        <span className="placeholder-line"></span>
                        <span className="placeholder-line"></span>
                        <span className="placeholder-line"></span>
                        <span className="placeholder-line"></span>
                        <span className="placeholder-line"></span>
                        <span className="placeholder-line"></span>
                    </div>
                </section>
                <section id="course-infos" className="grey">
                    <h2>Caractéristiques</h2>
                    <div className="content">
                        <ul className="items clearfix">
                            <li>
                                <span className="left">Prix public</span>
                                <span className="right"><span className="placeholder-line"></span></span>
                            </li>
                            <li>
                                <span className="left">Prix partenaire</span>
                                <span className="right"><span className="placeholder-line"></span></span>
                            </li>
                            <li>
                                <span className="left">Lieu</span>
                                <span className="right"><span className="placeholder-line"></span></span>
                            </li>
                            <li>
                                <span className="left">Niveau</span>
                                <span className="right"><span className="placeholder-line"></span></span>
                            </li>
                        </ul>
                    </div>
                </section>
                <section id="course-dates">
                    <h2>Dates</h2>
                    <div className="content">
                        <ul className="items clearfix">
                            <li>
                                <span className="placeholder-line"></span>
                            </li>
                            <li>
                                <span className="placeholder-line"></span>
                            </li>
                        </ul>
                    </div>
                </section>
                <section id="course-speakers" className="grey">
                    <h2>Intervenants</h2>
                    <div className="content">
                        <ul className="items clearfix">
                            <li>
                                <span className="title">
                                    <span className="placeholder-line"></span>
                                </span>
                                <span className="subtitle">
                                    <span className="placeholder-line"></span>
                                </span>
                            </li>
                            <li className="description">
                                <span className="placeholder-line"></span>
                                <span className="placeholder-line"></span>
                                <span className="placeholder-line"></span>
                            </li>
                        </ul>
                    </div>
                </section>
            </div>
        </div>
    </article>
);

export default CourseDetailsPlaceholder;



// WEBPACK FOOTER //
// ./src/features/Courses/components/Details/CourseDetailsPlaceholder.js